/**
 * src/data/OneTouchBank.js
 * Escalating 5-Scenario Loop for "Part 2: The One-Touch Rule"
 */

export const oneTouchBank = [
  {
    "id": "onetouch_01",
    "recipient": "Peer (Graphic Designer)",
    "scenarioContext": "You need them to share the link to the latest brand assets folder so you can finish a presentation deck.",
    "availableChips": [
      "Hey...",
      "Could you share the link",
      "Are you busy?",
      "to the brand assets folder?",
      "Quick question",
      "I need it for a deck.",
      "Got a sec?",
      "Ping me when free"
    ],
    "optimalMessageSequence": [
      "Could you share the link",
      "to the brand assets folder?",
      "I need it for a deck."
    ]
  },
  {
    "id": "onetouch_02",
    "recipient": "Cross-Functional Peer (DevOps Engineer)",
    "scenarioContext": "You need a DevOps engineer to review and approve a minor code fix before the mandatory 2 PM release freeze.",
    "availableChips": [
      "You around?",
      "Please review PR #402",
      "Hey man",
      "for the login fix",
      "Can I ask a favor?",
      "before the 2 PM freeze.",
      "When u have a min",
      "Thanks!"
    ],
    "optimalMessageSequence": [
      "Please review PR #402",
      "for the login fix",
      "before the 2 PM freeze.",
      "Thanks!"
    ]
  },
  {
    "id": "onetouch_03",
    "recipient": "Direct Manager (Director of Operations)",
    "scenarioContext": "You need your manager to quickly approve a $500 software license renewal so your team doesn't lose platform access tomorrow.",
    "availableChips": [
      "Hey boss",
      "I need your approval",
      "Got a quick minute?",
      "for the $500 Figma renewal",
      "Call me ASAP",
      "so we don't lose access",
      "Question...",
      "by tomorrow morning."
    ],
    "optimalMessageSequence": [
      "I need your approval",
      "for the $500 Figma renewal",
      "so we don't lose access",
      "by tomorrow morning."
    ]
  },
  {
    "id": "onetouch_04",
    "recipient": "External Vendor (API Support Lead)",
    "scenarioContext": "You need a vendor to clarify if their payment API will experience downtime during the critical Black Friday shopping weekend.",
    "availableChips": [
      "Hi there...",
      "Can you confirm if",
      "Are you the right person?",
      "the payment API will be down",
      "Just checking in",
      "during the Black Friday weekend?",
      "Quick ping",
      "We need to plan failovers."
    ],
    "optimalMessageSequence": [
      "Can you confirm if",
      "the payment API will be down",
      "during the Black Friday weekend?",
      "We need to plan failovers."
    ]
  },
  {
    "id": "onetouch_05",
    "recipient": "Executive (VP of Sales)",
    "scenarioContext": "The main CRM is currently down globally. You need to inform the VP before they panic, assuring them engineering is on it with an ETA.",
    "availableChips": [
      "Hey...",
      "The CRM is currently down.",
      "Bad news",
      "Engineering is investigating now,",
      "Are you seeing this?",
      "and we expect a fix",
      "Call me!!",
      "within 30 minutes."
    ],
    "optimalMessageSequence": [
      "The CRM is currently down.",
      "Engineering is investigating now,",
      "and we expect a fix",
      "within 30 minutes."
    ]
  }
];